import React from 'react';

import styled from 'styled-components';

export const Container = styled.div`
  padding: 8px 0 0;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 20px;
`;

export const Label = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: #5b5b5b;
  margin-bottom: 8px;
  letter-spacing: 1px;
`;

export const Select = styled.select`
  width: 100%;
  border: 1px solid #d8d8ea;
  border-radius: 4px;
  padding: 10px 12px;
  font-size: 14px;
  background: white;
  color: #2d2d2d;
  outline: none;
  cursor: pointer;
  font-family: 'JetBrains Mono Regular';

  &:disabled {
    background: #f5f5f7;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const FilterDropdown = ({
  label,
  placeholder,
  value,
  options = [],
  onChange,
  disabled = false,
  loading = false,
}) => {
  return (
    <FieldWrapper>
      <Label>{label}</Label>

      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || loading}
      >
        <option value="">{loading ? 'Loading...' : placeholder}</option>

        {options.map((item) => (
          <option key={item._id} value={item._id}>
            {item.regionName || item.precinctName}
          </option>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default FilterDropdown;
